webpackJsonp([192094587461937],{

/***/ 384:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulSection":{"content":{"childMarkdownRemark":{"html":"<h1>Portfolio on the way...</h1>\n<p>Someday, someday I'll get to this.</p>"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---portfolio-7069850265bf1feef68d.js